import { ApiResponse } from '@shared/models/api.model';
import axiosInstance from '../axios-instance';
import {
  DeviceChromeCastIdDialogFormData,
  DeviceCodeDataProps,
  DeviceImportPlaylistDialogFormProps,
  DevicesModel
} from '@modules/room-devices/model/devices.model.ts';

export const getRoomTVsDevices = async (
  params?: any
): Promise<ApiResponse<DevicesModel>> => {
  const response = await axiosInstance.get('/pms/devices/getter', {
    params
  });
  return response.data;
};

export const createRoomTVsDevices = async (
  body?: any
): Promise<ApiResponse<DevicesModel>> => {
  return await axiosInstance.post(`/pms/devices/register/admin`, body);
};

export const editRoomTVsDevicesRow = async (
  item?: any
): Promise<ApiResponse<DevicesModel>> => {
  const { _id, ...body } = item;
  return await axiosInstance.put(`/pms/devices/${_id}`, body);
};

export const deleteRoomTVsDevice = async (id: string): Promise<void> => {
  const data = { ids: [id], deviceLocation: 'room' };
  return await axiosInstance.delete(`/pms/devices`, { data });
};

export const deleteRoomTVsDevicesMany = async (id: string[]): Promise<void> => {
  const data = { ids: id, deviceLocation: 'room' };
  await axiosInstance.delete(`/pms/devices`, { data });
};

export const getRoomTVsGetRooms = async (
  params?: any
): Promise<ApiResponse<DevicesModel>> => {
  const response = await axiosInstance.get(
    '/pms/rooms/getter?query[limit]=1000',
    {
      params
    }
  );
  return response.data;
};

export const activeteDeviceForRoomWithCode = async (
  body?: any
): Promise<DeviceCodeDataProps> => {
  return await axiosInstance.post(`/pms/devices/activateForRoom`, body);
};

export const addPlaylistInDevice = async (
  body?: any
): Promise<DeviceImportPlaylistDialogFormProps> => {
  return await axiosInstance.put(`/media/playlists/attachDevice`, body);
};

export const removePlaylistInDevice = async (
  content?: any
): Promise<DeviceImportPlaylistDialogFormProps> => {
  const body = {
    deviceId: content.deviceId
  };
  return await axiosInstance.put(`/media/playlists/detachDevice`, body);
};

export const addChromeCastIDInDevice = async (
  item?: any
): Promise<DeviceChromeCastIdDialogFormData> => {
  const { id, ...body } = item;
  return await axiosInstance.put(`/pms/devices/addChromeCastId/${id}`, body);
};

export const getAllPlaylists = async (
  params?: any
): Promise<ApiResponse<any>> => {
  const response = await axiosInstance.get('/media/playlists', {
    params
  });
  return response.data;
};

export const getDevicePlaylists = async (
  deviceId?: any
): Promise<ApiResponse<any>> => {
  const response = await axiosInstance.get(
    `/media/playlists/byDeviceId/${deviceId}`
  );
  return response.data;
};

export const reloadManyDevices = async (id: string[]): Promise<void> => {
  const body = { ids: id, deviceLocation: 'room' };
  await axiosInstance.put(`/pms/devices/reload`, body);
};
